export default __webpack_public_path__ + "static/kacperk-e439006743a1bb5e742133d79bd0f639.jpg";